var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-menu-section flex flex-col items-between h-full"},[_c('ul',_vm._l((_vm.shopMenuSectionItems),function(item){return _c('section-item',{key:item._key,attrs:{"id":item.id,"scrim-id":_vm.scrimId,"section-item":item}})}),1),_vm._v(" "),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }